import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";
import Cookies from "js-cookie";

export const getLocationFromSession = async (data) => {
  const current_location = Cookies.get("current_location_localmandai");
  if (!current_location) {
    return "No Location Found";
  }
  try {
    const response = JSON.parse(current_location);
    return response;
  } catch (error) {
    console.log(error);
  }
};

// export const getCurrentLocation = async (data) => {
//   if (!navigator.geolocation) {
//     return "Geolocation is not supported by this browser.";
//   }
//   try {
//     navigator.geolocation.getCurrentPosition(
//       async (position) => {
//         const { latitude, longitude } = position.coords;
//         const apiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

//         try {
//           const response = await axios.get(
//             `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`
//           );

//           const results = response?.data?.results;
//           const addressDetails = response.data.results[0];
//           if (
//             !results ||
//             response.data.status !== "OK" ||
//             results.length === 0
//           ) {
//             return reject(
//               rejectWithValue("Failed to fetch accurate location data")
//             );
//           }

//           // Select best match
//           const bestMatch =
//             results.find(
//               (r) =>
//                 r.types.includes("street_address") ||
//                 r.types.includes("premise") ||
//                 r.types.includes("sublocality_level_1")
//             ) || results[0];

//           const addressComponents = bestMatch.address_components;

//           const getComponent = (types) => {
//             const match = addressComponents.find((comp) =>
//               types.some((type) => comp.types.includes(type))
//             );
//             return match?.long_name || "";
//           };

//           const addressParts = {
//             colony: getComponent(["neighborhood", "sublocality_level_2"]),
//             area: getComponent(["sublocality_level_1", "sublocality"]),
//             city: getComponent(["locality"]),
//             state: getComponent(["administrative_area_level_1"]),
//             country: getComponent(["country"]),
//             pincode: getComponent(["postal_code"]),
//           };

//           const formattedCustomAddress = [
//             addressParts.colony,
//             addressParts.area,
//             addressParts.city,
//             addressParts.state,
//             addressParts.country,
//             addressParts.pincode,
//           ]
//             .filter(Boolean)
//             .join(", ");

//           const fullLocationData = {
//             ...addressParts,
//             formatted_address: formattedCustomAddress,
//             raw: bestMatch,
//             coordinates: { lat: latitude, lng: longitude },
//             place_id: bestMatch.place_id,
//             types: bestMatch.types,
//           };

//           // Save to cookies
//           Cookies.set(
//             "current_location_grocido",
//             JSON.stringify(fullLocationData)
//           );

//           // Dispatch to Redux store
//           dispatch(setCurrentLocation(addressDetails));

//           resolve(fullLocationData);
//         } catch (error) {
//           console.error("Error fetching location from Google Maps:", error);
//           reject(rejectWithValue("Google Maps API error"));
//         }
//       },
//       (error) => {
//         console.error("Geolocation error:", error);
//         reject(rejectWithValue("Failed to get geolocation data"));
//       }
//     );
//   } catch (error) {
//     console.log(error);
//   }
// };

export const Login = async (data) => {
  try {
    const res = await postData(`/auth/login`, data);

    return res;
  } catch (error) {
    console.log(error);
  }
};
